// app/javascript/controllers/incoming_invoice_line_allocations_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["assignment", "panel", "container", "template"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasAssignmentTarget || !this.hasPanelTarget) return

    const direct = this.assignmentTarget.value === "direct"
    this.panelTarget.classList.toggle("d-none", !direct)
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replaceAll(
      "NEW_ALLOCATION_RECORD",
      new Date().getTime().toString()
    )

    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-allocation-row]")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }
  }
}
